// auth/admin.guard.ts
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, take } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { isAdmin as isAdminUser, Logger, User } from 'shared';

export const adminGuard: CanActivateFn = (route, state) => {
  const authService: AuthService = inject(AuthService);
  const router: Router = inject(Router);
  const logger = new Logger('adminGuard: CanActivateFn');

  return authService.getUser$().pipe(
    take(1),
    map((user: User | null) => {
      if (!user) {
        logger.debug(`NOT LOGGED IN => CANNOT ACTIVATE: ${route.url}. PERFORM NAVIGATION TO /login`);
        router.navigate(['/login']);
        return false;
      }

      const isAdmin = isAdminUser(user);
      if (isAdmin) {
        logger.debug(`ADMIN USER => CAN ACTIVATE: ${route.url}`);
        return true;
      }

      logger.warn(`NON-ADMIN USER => CANNOT ACTIVATE: ${route.url}. PERFORM NAVIGATION TO /en`);
      router.navigate(['/en']);
      return false;
    })
  );
};
